import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {
  DeclaracionAdheridoControllerService,
  DeclaracionAdheridoDTO,
  DeclaracionCentroDTO,
  DeclaracionEnvaseControllerService,
  DeclaracionEnvaseFilterDTO,
} from 'api-rest';
import { PackageDialogComponent } from '../package-dialog/package-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { SpinnerService } from '../../../services/spinner.service';
import { SnackbarService } from '../../../services/snackbar.service';
import { PageDTODeclaracionEnvaseDTO } from 'api-rest';
import { DeclaracionEnvaseDTO } from 'api-rest';
import { CombosService } from '../../../services/combos.service';
import Swal from 'sweetalert2';
import { DownloadService } from '../../../services/download.service';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import { FormatCurrencyPipe } from '../../../share/components/pipe/FormatCurrency.pipe';
import {ParseCurrencyPipe} from '../../../share/components/pipe/ParseCurrency.pipe';


@Component({
  selector: 'lib-package-center-packaging',
  templateUrl: './package-center-packaging.component.html',
  styleUrls: ['./package-center-packaging.component.scss'],
})
export class PackageCenterPackagingComponent implements OnInit {
  @Input() centro!: DeclaracionCentroDTO;
  @Output() actualizarImportar: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Output() actualizarDeclaracion: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Output() actualizarEnvases: EventEmitter<any> =
    new EventEmitter<any>();
  @Input() declaracionAdherido!: DeclaracionAdheridoDTO;

  formGroup: FormGroup;
  tipoEnvasesEndpoint =
    this.environment.urlBackCore + 'api/v1/core/tipoEnvases';
  updateList: boolean = false;

  gridArray: any[] = [];

  pageNumber: number = 0;
  pageSize: number = 25;
  totalElements: number = 0;
  itemsPerPageOptions: number[] = [25, 50, 75, 100];
  selectedItemsPerPage: number = 25;
  flagSearch: boolean = false;
  totalSearch: any = 0;
  defaultSort: string = '';
  currentSort: string = '';
  EPSILON = 0.0001;

  headArray: any = [
    {
      Head: 'Denominación',
      FieldName: 'denominacion',
      Tooltip: true,
    },
    {
      Head: '',
      FieldName: 'actions',
      buttons: [
        {
          nameButton: 'warning',
          icon: 'warning',
          toolTip:
            'Revise los datos de este tipo de envase porque el resultado registrado no era correcto',
          show: (row: any) => (this.showWarning(row)) || (this.validarPeso(row)),
        },
        {
          nameButton: 'warning',
          icon: 'warning',
          toolTip:
            'Añada mínimo un material de composición',
          color: '#86BC25',
          show: (row: any) => (this.showWarningMaterial(row)),
        },
        {
          nameButton: 'warning',
          icon: 'warning',
          toolTip:
            'Solo los envases de tipología primaria pueden ser peligrosos',
          show: (row: any) => this.showWarningPeligrosidad(row),
        },
        {
          nameButton: 'warning',
          icon: 'warning',
          toolTip:
            'La tipología del envase no es válida para el tipo de envase seleccionado',
          show: (row: any) => this.showWarningTipologiaInvalida(row),
        },
        {
          nameButton: 'warning',
          icon: 'warning',
          toolTip: 'Las unidades declaradas deben ser mayores que 0',
          show: (row: any) => this.showWarningUnidadesCero(row),
        },
      ],
      
    },
    {
      Head: 'Tipo envase',
      FieldName: 'tipoEnvase',
      Attribute: 'descripcion',
      Tooltip: true,
    },
    {
      Head: 'Peligrosidad',
      FieldName: 'peligrosidad',
      renderValue: (item: DeclaracionEnvaseDTO) =>
        item.peligrosidad ? 'SI' : 'NO',
    },
    {
      Head: 'Tipología',
      FieldName: 'tipologia',
    },
    {
      Head: 'Unidades',
      FieldName: 'unidadesTotales',
      renderValue: (item: any) =>{
        if ([3, 4].includes(item.declaracionCentro?.categoriaEnvase?.id!)) {
          return this.formatCurrencyPipe.transform(item.unidadesNuevas);
        } else {
          return this.formatCurrencyPipe.transform(item.unidadesTotales);
        }
      },
    },
    {
      Head: 'Peso unitario (Kg)',
      FieldName: 'pesoUnitario',
    },
    {
      Head: 'Peso total (Kg)',
      FieldName: 'pesoTotal',
    },
    {
      Head: 'Acciones',
      FieldName: 'actions',
      check: true,
      buttons: [
        {
          nameButton: 'view',
          icon: 'open_in_new',
          toolTip: 'Detalle',
          show: { params: 'canAccessView', accion: 'view' },
        },
        {
          nameButton: 'delete',
          icon: 'delete',
          toolTip: 'Borrar',
          show: { params: 'canAccessDelete', accion: 'delete' },
        },
      ],
      width: '8',
      permanent: true,
    },
  ];

  constructor(
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    @Inject('environment') private environment: any,
    private declaracionEnvaseControllerSrv: DeclaracionEnvaseControllerService,
    private declaracionAdheridoControllerSrv: DeclaracionAdheridoControllerService,
    public spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    private comboSrv: CombosService,
    private downloadSrv: DownloadService,
    @Inject('EmpusaAuthenticationService')
    public authService: EmpusaAuthenticationService,
    private formatCurrencyPipe: FormatCurrencyPipe,
    private parseCurrencyPipe: ParseCurrencyPipe,
  ) {
    this.formGroup = this.formBuilder.group({
      denominacion: [{ value: null, disabled: false }, Validators.maxLength(255)],
      tipoEnvase: [{ value: null, disabled: false }],
    });
  }
  ngOnInit(): void {
    this.buscar();
  }

  limpiar(): void {
    this.formGroup.reset();
  }

  exportar(): void {
    //let filtro: DeclaracionEnvaseFilterDTO = this.obtenerFiltro();
    this.spinnerSrv.loadingShow();
    this.declaracionEnvaseControllerSrv.exportDeclaracionEnvases(this.centro.id!, 'response')
      .subscribe((res) => {
        // this.downloadSrv.exportModal();
        this.spinnerSrv.loadingHide();
        const fileName = this.downloadSrv.getFileName(res.headers, 'envases.xlsx');
        this.downloadSrv.downloadBlob(res.body!, fileName!);
      });
  }

  obtenerFiltro(): DeclaracionEnvaseFilterDTO {
    // filtrado
    const textFilter = (value: any) =>
      value?.trim() ? value?.trim() : undefined;
    let filtro: DeclaracionEnvaseFilterDTO = {};
    if (this.centro?.id) {
      filtro.declaracionCentro = { id: [this.centro.id!.toString()] };
    }
    if (this.formGroup.get('tipoEnvase')?.value) {
      filtro.tipoEnvase = {
        id: [this.formGroup.get('tipoEnvase')?.value.id.toString()],
      };
    }
    filtro.denominacion = textFilter(this.formGroup.get('denominacion')?.value?.trim());

    return filtro;
  }
  buscar(): void {
    // filtrado
    let filtro: DeclaracionEnvaseFilterDTO = this.obtenerFiltro();
    const sort = this.currentSort != '' ? this.currentSort : this.defaultSort;
    // paginación
    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
    let pag = {
      page: page,
      size: this.pageSize,
      sort: [sort],
    };
    this.spinnerSrv.loadingShow();
    this.declaracionEnvaseControllerSrv.findAll4(filtro, pag).subscribe({
      next: (response: PageDTODeclaracionEnvaseDTO) => {
        this.spinnerSrv.loadingHide();
        this.gridArray = this.canAccessAll(response?.datos!);
        this.flagSearch = response.datos?.length != 0 ? true : false;
        this.totalSearch = this.gridArray.length;
        this.totalElements = response?.paginacion?.totalElements!;
        this.flagSearch
          ? this.actualizarImportar.emit(false)
          : this.actualizarImportar.emit(true);
        this.actualizarEnvases.emit({idCentro: this.centro?.id, numEnvases: this.totalSearch});
        this.actualizarEncabezadoUnidades(this.gridArray)
      },
      error: (err: any) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(
          'Ha ocurrido un error al buscar los envases',
          'error'
        );
      },
    });
  }

  actualizarEncabezadoUnidades(datos: any[]) {
    const columnaUnidades = this.headArray.find((col: any) => col.FieldName === 'unidadesTotales');

    if (columnaUnidades) {
      const sonTodosEspeciales = datos.every(item => 
        [3, 4].includes(item.declaracionCentro?.categoriaEnvase?.id)
      );

      if (sonTodosEspeciales) {
        columnaUnidades.Head = 'Unidades Nuevas';
      } else {
        columnaUnidades.Head = 'Unidades';
      }
    }
  }

  showWarning(row: any) {
    var unidades = 0;

    if([3, 4].includes(row.declaracionCentro?.categoriaEnvase?.id)){
      unidades = Number(row.unidadesNuevas);
    }else{
      unidades = Number(row.unidadesTotales);
    }
  const unitario = this.parseCurrencyPipe.transform(row.pesoUnitario);
  const pesoUnitarioCalculado = this.parseCurrencyPipe.transform(row.pesoTotal) / unidades
  const totalDeclarado = this.parseCurrencyPipe.transform(row.pesoTotal);
  const totalCalculado = unidades * unitario;

  if(Math.abs(totalCalculado - totalDeclarado) < this.EPSILON || Math.abs(pesoUnitarioCalculado - unitario) < this.EPSILON){
    return false;
  }else{
    return true;
  }
  // return Math.abs(totalCalculado - totalDeclarado) > this.EPSILON ? true : false;
  }
  showWarningMaterial(row: any) {
    const materials = Array.isArray(row?.envaseMaterial)
      ? row.envaseMaterial
      : row?.envaseMaterial
      ? [row.envaseMaterial]
      : [];

    if (!materials || materials.length === 0) {
      return true;
    }

    // Si ninguno de los elementos tiene tipoElemento === null, es que no tiene materiales de composición
    const noneTipoElementoNull = materials.every((m: any) => m?.tipoElemento !== null);
    if (noneTipoElementoNull) return true;
    return false;
  }
  action(item: any) {
    if (item.nameButton == 'view') {
      this.abrirModalEnvase(item, false);
    } else if (item.nameButton == 'delete') {
      this.confirmacionEliminar(item);
    }
  }
  confirmacionEliminar(element?: DeclaracionEnvaseDTO): void {
    Swal.fire({
      text: `¿Desea eliminar el envase?`,
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed && element?.id) {
        this.eliminarEnvase(element?.id);
      }
    });
  }

  confirmacionEliminarSeleccionados(): void {
    const list = this.gridArray
      .filter((x) => x.checked === true)
      .map((x) => x.id);
    
    if (list.length == 0) {
      this.snackBarSrv.showSnackBar(
        `Debe seleccionar al menos un envase para eliminar.`,
        'error'
      );
      return;
    }
    Swal.fire({
      text: `¿Desea eliminar los envases seleccionados?`,
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.eliminarMultiplesEnvases(list);
      }
    });
  }

  eliminarEnvase(id: number): void {
    this.spinnerSrv.loadingShow();
    this.declaracionEnvaseControllerSrv.deleteById3(id).subscribe({
      next: (response) => {
        this.spinnerSrv.loadingHide();
        this.buscar();
        this.snackBarSrv.showSnackBar(
          'El envase se ha borrado correctamente',
          'success'
        );
        this.actualizarDeclaracion.emit(true);
      },
      error: (err: any) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(
          'Ha ocurrido un error al borrar el envase',
          'error'
        );
      },
    });
  }

  eliminarMultiplesEnvases(list:any){
    this.spinnerSrv.loadingShow();
    this.declaracionEnvaseControllerSrv.deleteAllById(list).subscribe({
      next: (response) => {
        this.spinnerSrv.loadingHide();
        this.buscar();
        this.snackBarSrv.showSnackBar(
          'Los envases se han borrado correctamente',
          'success'
        );
        this.actualizarDeclaracion.emit(true);
      },
      error: (err: any) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(
          'Ha ocurrido un error al borrar el envase',
          'error'
        );
      },
    });
  }

  abrirModalEnvase(item: any, titulo: boolean): void {
    const dialogRef = this.dialog.open(PackageDialogComponent, {
      width: '1460px',
      maxWidth: '95%',
      maxHeight: '95vh',
      data: {
        item: item,
        declaracionCentro: this.centro,
        nuevoEnvase: titulo,
        declaracionAdherido: this.declaracionAdherido,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.limpiar();
        this.buscar();
        this.actualizarResumenEconomico();
      }
    });
  }

  actualizarResumenEconomico() {
    this.spinnerSrv.loadingShow();
    this.declaracionAdheridoControllerSrv
      .actualizarResumenEconomico(this.declaracionAdherido.id!)
      .subscribe({
        next: (res) => {
          this.declaracionAdherido.contriRapAnioCursoAbierto =
            res.contriRapAnioCursoAbierto;
          this.declaracionAdherido.contriRapAnioAnteriorAbierto =
            res.contriRapAnioAnteriorAbierto;
          this.declaracionAdherido.depoRapAnioCursoAbierto =
            res.depoRapAnioCursoAbierto;
          this.declaracionAdherido.depoRapAnioAnteriorAbierto =
            res.depoRapAnioAnteriorAbierto;

          this.declaracionAdherido.contriRapAnioCursoCerrado =
            res.contriRapAnioCursoCerrado;
          this.declaracionAdherido.contriRapAnioAnteriorCerrado =
            res.contriRapAnioAnteriorCerrado;
          this.declaracionAdherido.depoRapAnioCursoCerrado =
            res.depoRapAnioCursoCerrado;
          this.declaracionAdherido.depoRapAnioAnteriorCerrado =
            res.depoRapAnioAnteriorCerrado;

          this.declaracionAdherido.contriRapAnioCursoSoloUso =
            res.contriRapAnioCursoSoloUso;
          this.declaracionAdherido.contriRapAnioAnteriorSoloUso =
            res.contriRapAnioAnteriorSoloUso;

          this.declaracionAdherido.reqActEconomica = res.reqActEconomica;

          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'El resumen económico se ha actualizado correctamente',
            'success'
          );
          this.actualizarDeclaracion.emit(true);
        },
        error: (error) => {
          if (error.error.detail) {
            this.snackBarSrv.showSnackBar(error.error.detail, 'error');
          } else {
            this.snackBarSrv.showSnackBar(
              'Ha ocurrido un error al actualizar el resumen económico',
              'error'
            );
          }
          this.spinnerSrv.loadingHide();
        },
      });
  }

  

  getFormControl(): FormControl {
    return this.formGroup.get('tipoEnvase') as FormControl;
  }
  public filterList(data: any) {}

  renderPage(event: number) {
    // console.log('renderpage', event);
    this.pageNumber = event;
    if (this.flagSearch) {
      this.buscar();
    }
  }

  onItemsPerPageChange() {
    this.pageSize = this.selectedItemsPerPage;
    this.buscar();
  }

  canAccessNewEnv(): boolean {
    return this.authService.can('dec_envases-envases', 'access-b-envases');
  }

  canAccessExportEnv(): boolean {
    return this.authService.can('dec_envases-envases', 'update-exportar');
  }

  canAccessAll(list: any) {
    const resultView = this.authService.can('dec_envases-envases', 'view');
    const resultDelete = this.authService.can('dec_envases-envases', 'delete');

    const listPermission = list.map((objeto: any) => {
      return {
        ...objeto,
        canAccessView: resultView,
        canAccessDelete: resultDelete && this.canAccessEditAllGlobal(),
        pesoUnitario: this.formatCurrencyPipe.transform(objeto.pesoUnitario),
        pesoTotal: this.formatCurrencyPipe.transform(objeto.pesoTotal),
      };
    });

    return listPermission;
  }

  convertToComma(value: any): string {
    if (typeof value === 'number') {
      let stringValue = value.toFixed(5).replace('.', ',');
      stringValue = stringValue.replace(/,?0+$/, '');
      return stringValue;
    } else if (typeof value === 'string') {
      return value.replace('.', ',').replace(/,?0+$/, '');
    } else {
      return '0';
    }
  }

  canAccessEditAllGlobal(): boolean {
    return (
      this.authService.can('dec_envases', 'update') &&
      this.declaracionAdherido?.estadoDeclaracion?.id == 0
    );
  }

  canAccessDeleteAll(): boolean{
    const resultDelete = this.authService.can('dec_envases-envases', 'delete');
    return resultDelete && this.canAccessEditAllGlobal();
  }

  sortGrid(element: any){
    this.currentSort = '';
    let colName = element.name;
    if(colName != null && colName != undefined){
      if(colName == 'unidadesTotales'){
        colName = 'unidades';
      }
    }
    if(colName != ''){
      this.currentSort = `${colName},${element.type}`;
    }
    this.pageNumber = 0;
    this.buscar();
  }

  comprobarCategoriaCentro(){
    if(this.centro.categoriaEnvase?.id === 9){
      return false
    }
    return true;
  }
  
  isCategoriaSoloUso(): boolean {
    return [1, 2].includes(this.centro?.categoriaEnvase?.id!);
  }

  isCategoriaSDDRCerrado(): boolean {
    return [3, 4].includes(this.centro?.categoriaEnvase?.id!);
  }

  isCategoriaSDDRAbierto(): boolean {
    return [5, 6].includes(this.centro?.categoriaEnvase?.id!);
  }

  validarPeso(row: any) {
    let sumaPesoUnitario = 0;
    let sumaPesoTotal = 0;
    for (const material of row.envaseMaterial) {
      sumaPesoUnitario += Number(material.pesoUnitario);
      sumaPesoTotal += Number(material.pesoTotal);
    }

    return (Math.abs(sumaPesoUnitario - this.parseCurrencyPipe.transform(row.pesoUnitario)) < this.EPSILON)
      && (Math.abs(sumaPesoTotal - this.parseCurrencyPipe.transform(row.pesoTotal)) < this.EPSILON)
      ? false : true;
  }

    showWarningPeligrosidad(row: any): boolean {
    return row.peligrosidad === true && row.tipologia !== 'PRIMARIO';
  }

  showWarningTipologiaInvalida(row: any): boolean {
    return !this.esTipologiaValidaParaEnvase(row.tipoEnvase, row.tipologia);
  }

  esTipologiaValidaParaEnvase(tipoEnvase: any, tipologia: string): boolean {
    if (!tipoEnvase || !tipologia) {
      return true;
    }
    if (this.isCategoriaSDDRAbierto()) {
      if (tipoEnvase.descripcion === 'IBC, GRG') {
        return tipologia === 'PRIMARIO';
      }
      if (tipoEnvase.descripcion === 'Pallet, palet, paleta') {
        return tipologia === 'TERCIARIO';
      }
      return false;
    }
    return [tipoEnvase.tipologia1, tipoEnvase.tipologia2, tipoEnvase.tipologia3].includes(tipologia);
  }

  showWarningUnidadesCero(row: any): boolean {
  let unidades = 0;
  if ([3, 4].includes(row.declaracionCentro?.categoriaEnvase?.id)) {
    unidades = Number(row.unidadesNuevas);
  } else {
    unidades = Number(row.unidadesTotales);
  }
  return !(unidades > 0);
}
}
